import React from "react";
import FacebookLogin from "react-facebook-login";
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles({
  //   button: {
  //     marginRight: "10px",
  //     background: "rgb(255, 255, 255)",
  //     padding: "10px 8px",
  //     borderRadius: "2px",
  //     color: "#4267b2",
  //     fontSize: "22px"
  //   }
  button: {
    "& i": {
      marginRight: "10px",
      background: "rgb(255, 255, 255)",
      padding: "10px 8px",
      borderRadius: "2px",
      color: "#4267b2",
      fontSize: "22px"
    },
    backgroundColor: "rgb(255, 255, 255)",
    display: "inline-flex",
    alignItems: "center",
    color: "rgba(0, 0, 0, 0.54)",
    boxShadow:
      "rgba(0, 0, 0, 0.24) 0px 2px 2px 0px,rgba(0, 0, 0, 0.24) 0px 0px 1px 0px",
    padding: "0px 10px 0 0",
    borderRadius: "2px",
    border: "1px solid transparent",
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "Roboto, sans-serif",
    cursor: "pointer"
  },
  buttonfa: {
    padding: "0px 0px 5px 10px"
  }
});
export default function FacebookLoginForm(props) {
  const classes = useStyles();
  const { multiLang, lang, dir } = props;
  function responseFacebook(response) {
    console.log(response);
    props.login(response.accessToken);
  }
  return (
    <div>
      <FacebookLogin
        appId="466405607259507"
        autoLoad={false}
        fields="name,email,picture"
        callback={responseFacebook}
        cssClass={classes.button + " " + (dir === "rtl" && classes.buttonfa)}
        icon={<i className="fab fa-facebook-square" />}
        textButton={multiLang["028"][lang]}
      />
    </div>
  );
}
